import { render, staticRenderFns } from "./InvalidSession.vue?vue&type=template&id=2ec54591&scoped=true&"
import script from "./InvalidSession.vue?vue&type=script&lang=js&"
export * from "./InvalidSession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec54591",
  null
  
)

export default component.exports